import { SerializedError, createSlice } from '@reduxjs/toolkit';

import { bannersApiUrlCreator } from '@lib/core/banners/slices/urls';
import { TBanner, TGetBannersParams } from '@lib/core/banners/types';
import { createTypedAsyncThunk } from '@lib/core/service/createTypedAsyncThunk';
import { request } from '@lib/core/service/requests/request';

interface IState {
  data: TBanner[];
  error: SerializedError;
  isLoading: boolean;
}

const initialState: IState = {
  data: [],
  error: null,
  isLoading: false,
};

export const actionGetBanners = createTypedAsyncThunk<TBanner[], TGetBannersParams>(
  'actionGetBanners',
  async params => {
    const { results = [] } = await request({
      params,
      url: bannersApiUrlCreator(),
    });
    return results;
  },
);

export const bannersSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionGetBanners.pending, state => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(actionGetBanners.fulfilled, (state, { payload }) => {
      state.data = payload;
      state.isLoading = false;
    });
    builder.addCase(actionGetBanners.rejected, (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    });
  },
  initialState,
  name: 'banners',
  reducers: {},
});

export default bannersSlice.reducer;
